import { observable, action } from 'mobx';

export class LoadingStore {
  @observable showAppIsBusy: boolean = false;

  @action appIsBusy(): void {
    this.showAppIsBusy = true;
    console.log(`appIsBusy: ${this.showAppIsBusy}`);
  }

  @action appIsNotBusy(): void {
    this.showAppIsBusy = false;
    console.log(`appIsBusy: ${this.showAppIsBusy}`);
  }
}